import type { AddOnPurchaseProduct } from "../activity/add-on-purchase/types";
import React, { useContext } from "react";
import CartItem from "./CartItem";
import { getRuleType, getRules } from "../../utils/activityHelper";
import { AppContext } from "Store";
export interface ProductRule {
  id: number;
  categoryName?: string;
  categoryType: string;
  categoryTypeValue: number;
  maxQuantity?: number;
  maxAmount?: number;
  minQuantity?: number;
  minAmount?: number;
  minItem?: number;
  maxItem?: number;
  activityId: number;
  type: string;
}
export interface ICartItem {
  id: number;
  sku: string;
  activityId: number;
  quantity: number;
  productRuleId: number;
  product: {
    sku: string;
    category: string;
    subCategory: string;
    finalPrice: string;
    purchaseType?: AddOnPurchaseProduct["purchaseType"];
    limitQty?: number | null;
    productName: string;
    productPic: string;
    productSize: string;
    description: string;
    listPrice: string;
    promoPrice?: string;
    pdpViewable: boolean;
  };
}
export interface ProductGroupProps {
  tab: string;
  groupItem: {
    matchRule: boolean;
    productRule: ProductRule;
    cartItems: ICartItem[];
  };
  [key: string]: any;
}

const ProductGroup: React.FC<ProductGroupProps> = (props) => {
  const { tab, groupItem, cartData, noTabData, isAddOnPurchase, ...rest } = props;
  const { loginState } = useContext(AppContext);
  const { matchRule, productRule, cartItems } = groupItem;
  const { categoryName, categoryType } = productRule;
  const noItems = !cartItems?.length && categoryType === "specify_category";
  const groups = cartData[tab].productGroup;
  const groupRules = getRules(productRule, { tab });

  return (
    <div className="groupWrapper">
      {isAddOnPurchase && <div className="groupHead" aria-hidden="true" />}
      {!isAddOnPurchase && (<div className="groupHead">
        <div className="title">{getRuleType(groupItem, groups)}</div>
        <div className="limitWrapper">
          <div className={matchRule ? "rules" : "rules highlight"}>
            {groupRules?.map((rule, index) => {
              return (
                <span key={index} className="ruleItem">
                  {rule}
                </span>
              );
            })}
          </div>
          {noItems && (
            <div>
              {groupRules?.length ? <span>，</span> : null}
              <span
                className="textLink noWrap"
                onClick={() => {
                  const filterMap = new Map();
                  filterMap.set(categoryName, "all");
                  props.setFilteredCategories({
                    activeTab: tab,
                    filteredMap: filterMap,
                    pageConf: {
                      pageNum: 1,
                      pageSize: props.filteredCategories.pageConf.pageSize,
                    },
                  });
                  props.setOpenCartDrawer(false);
                }}
              >
                前往选择
              </span>
            </div>
          )}
        </div>
      </div>)}
      <div className="cartItems">
        {cartItems?.map((item, index) => {
          return (
            <CartItem
              key={item.id}
              loginState={loginState}
              cartItem={item}
              {...rest}
            ></CartItem>
          );
        })}
      </div>
    </div>
  );
};

export default ProductGroup;
